import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Sidebar.css';

const Sidebar: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  
  return (
    <>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {collapsed ? '☰' : '✕'}
      </button>

      <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <h2>Ferramentas</h2>
        <ul>
          <li>
            <Link
              to="/word-counter"
              className={
                location.pathname === '/word-counter' || location.pathname === '/'
                  ? 'active'
                  : ''
              }
            >
              Contador de Palavras
            </Link>
          </li>
          <li>
            <Link
              to="/json-formatter"
              className={location.pathname === '/json-formatter' ? 'active' : ''}
            >
              Formatador de JSON
            </Link>
          </li>
          <li>
            <Link
              to="/image-resizer"
              className={location.pathname === '/image-resizer' ? 'active' : ''}
            >
              Redimensionador de Imagem
            </Link>
          </li>
          <li>
            <Link
              to="/pdf-converter"
              className={location.pathname === '/pdf-converter' ? 'active' : ''}
            >
              Conversor para PDF
            </Link>
          </li>
          <li>
            <Link
              to="/youtube-downloader"
              className={location.pathname === '/youtube-downloader' ? 'active' : ''}
            >
              Baixar do YouTube
            </Link>
          </li>
            <li>

              <Link
                to="/text-case-converter"
                className={location.pathname === '/text-case-converter' ? 'active' : ''}
              >
                Conversor de Caixa
              </Link>
            </li>
            <li>
              <Link
                to="/api-key-generator"
                className={location.pathname === '/api-key-generator' ? 'active' : ''}
              >
                Gerador de API Key
              </Link>
            </li>


        

        </ul>
      </div>
    </>
  );
};

export default Sidebar; 